import React, { useState, useEffect } from "react";
import {
  Card,
  Row,
  Col,
  Spinner,
  Alert,
  Button,
  ListGroup,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import {
  FiAward,
  FiCalendar,
  FiShield,
  FiTable,
  FiUsers,
} from "react-icons/fi";

// Mock API URL - will need to be implemented in backend
const API_URL = process.env.REACT_APP_API_URL;

const Dashboard = () => {
  const [stats, setStats] = useState({
    teams: 0,
    players: 0,
    seasons: 0,
  });
  const [upcomingMatches, setUpcomingMatches] = useState([]);
  const [recentResults, setRecentResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDashboardData = async () => {
      setLoading(true);
      setError("");
      try {
        const [
          teamCountRes,
          playerCountRes,
          seasonCountRes,
          upcomingRes,
          recentRes,
        ] = await Promise.all([
          axios.get(`${API_URL}/teams/count`),
          axios.get(`${API_URL}/players/count`),
          axios.get(`${API_URL}/seasons/count`),
          axios.get(`${API_URL}/schedules/upcoming`),
          axios.get(`${API_URL}/schedules/recent`),
        ]);

        setStats({
          teams: teamCountRes.data.total || 0,
          players: playerCountRes.data.total || 0,
          seasons: seasonCountRes.data.total || 0,
        });

        setUpcomingMatches(upcomingRes.data);
        setRecentResults(recentRes.data);
      } catch (err) {
        setError("Không thể tải dữ liệu dashboard.");
        console.error("Dashboard fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const StatCard = ({ title, value, icon: Icon, tone = "" }) => (
    <Card className="admin-stat-card">
      <Card.Body>
        <div className={`admin-stat-icon ${tone}`}>
          <Icon />
        </div>
        <div>
          <span>{title}</span>
          <strong>{value}</strong>
        </div>
      </Card.Body>
    </Card>
  );

  return (
    <div className="admin-dashboard">
      <div className="admin-page-intro">
        <div>
          <span>Tổng quan hệ thống</span>
          <h2>Bảng điều khiển</h2>
          <p>Theo dõi nhanh đội, vận động viên, mùa giải và lịch thi đấu gần nhất.</p>
        </div>
      </div>
      {error && <Alert variant="warning">{error}</Alert>}

      <Row className="mb-4 g-4">
        <Col md={4}>
          <StatCard title="Tổng số đội" value={stats.teams} icon={FiShield} />
        </Col>
        <Col md={4}>
          <StatCard
            title="Tổng số VĐV"
            value={stats.players}
            icon={FiUsers}
            tone="blue"
          />
        </Col>
        <Col md={4}>
          <StatCard
            title="Mùa giải"
            value={stats.seasons}
            icon={FiAward}
            tone="violet"
          />
        </Col>
      </Row>

      <Card className="mb-4">
        <Card.Header as="h5">Lối tắt</Card.Header>
        <Card.Body>
          <Row className="g-3">
            <Col md={3} sm={6}>
              <Button
                as={Link}
                to="/schedules"
                variant="outline-primary"
                className="w-100 admin-quick-link"
              >
                <FiCalendar />
                Lịch thi đấu
              </Button>
            </Col>
            <Col md={3} sm={6}>
              <Button
                as={Link}
                to="/tables"
                variant="outline-secondary"
                className="w-100 admin-quick-link"
              >
                <FiTable />
                Bảng đấu
              </Button>
            </Col>
            <Col md={3} sm={6}>
              <Button
                as={Link}
                to="/players"
                variant="outline-info"
                className="w-100 admin-quick-link"
              >
                <FiUsers />
                Vận động viên
              </Button>
            </Col>
            <Col md={3} sm={6}>
              <Button
                as={Link}
                to="/rosters"
                variant="outline-dark"
                className="w-100 admin-quick-link"
              >
                <FiShield />
                Quản lý đội
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Row>
        <Col md={6}>
          <Card>
            <Card.Header as="h5">Lịch thi đấu sắp tới</Card.Header>
            <ListGroup variant="flush">
              {loading ? (
                <Spinner animation="border" className="m-3" />
              ) : (
                upcomingMatches.map((match) => (
                  <ListGroup.Item
                    key={match.id}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      {match.home_team_name} vs {match.guest_team_name}
                    </span>
                    <small className="text-muted">{match.play_date}</small>
                  </ListGroup.Item>
                ))
              )}
            </ListGroup>
          </Card>
        </Col>
        <Col md={6}>
          <Card>
            <Card.Header as="h5">Kết quả gần đây</Card.Header>
            <ListGroup variant="flush">
              {loading ? (
                <Spinner animation="border" className="m-3" />
              ) : (
                recentResults.map((match) => (
                  <ListGroup.Item
                    key={match.id}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      {match.home_team_name} vs {match.guest_team_name}
                    </span>
                    <strong>
                      {match.home_result} - {match.guest_result}
                    </strong>
                  </ListGroup.Item>
                ))
              )}
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
